import { Delete } from "@mui/icons-material";

const CustomTrashComponent = (props: any) => {
    const onDelete = async () => {
        const rowData = props.data;
        await props.context.handleDelete(rowData.id);
    };

    return (
        <button className="btn-trash" onClick={onDelete}>
            <Delete />
        </button>
    );
};

export default CustomTrashComponent;
